import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class NotificationService {
    /**
     * Subscribe Notifications
     * SSE provider endpoint for notifications.
     *
     * Provides an EventSourceResponse stream with the SSEGenerator for the user
     * specified with the Depends dependency tree.
     * @returns any Successful Response
     * @throws ApiError
     */
    static subscribeNotifications() {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/noti/subscribe',
        });
    }
    /**
     * Get All Notifications
     * Retrieve all notifications for a user.
     * @param includeRead
     * @param userId
     * @returns UserNotification Successful Response
     * @throws ApiError
     */
    static getAllNotifications(includeRead = false, userId) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/noti',
            query: {
                'include_read': includeRead,
                'user_id': userId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Notification Test
     * Test endpoint to create a notification.
     *
     * Will be gated to dev users.
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static createNotificationTest(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/noti',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Read Notification
     * Mark a notification as read.
     * @param notifId
     * @param read
     * @returns any Successful Response
     * @throws ApiError
     */
    static readNotification(notifId, read = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/noti/{notif_id}/read',
            path: {
                'notif_id': notifId,
            },
            query: {
                'read': read,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Notification
     * Delete a notification.
     * @param notifId
     * @returns any Successful Response
     * @throws ApiError
     */
    static deleteNotification(notifId) {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/noti/{notif_id}',
            path: {
                'notif_id': notifId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
